export default "__VITE_ASSET__$ER1Dpjm__"